/********************************************************************
 * GESTIÓN COOKIES
 ********************************************************************/
function leerCookie(nombre) {
  var nombreEQ = nombre + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nombreEQ) == 0) return c.substring(nombreEQ.length,c.length);
  }
  return null;
}

function grabarCookie(nombre, valor, dias) {
  var fecha = new Date();
  fecha.setTime(fecha.getTime() + (dias*24*60*60*1000));
  var expira = "expires="+ fecha.toUTCString();
  document.cookie = nombre + "=" + valor + ";" + expira + ";path=/";
}

/********************************************************************
 * FECHAS
 ********************************************************************/
function fecha_dia() {
  var fecha = new Date();

  var anio = fecha.getFullYear();
  var mes = fecha.getMonth() + 1; // Los meses comienzan desde 0
  var dia = fecha.getDate();

  // Añadir un 0 delante para los meses y días menores de 10
  mes = mes < 10 ? '0' + mes : mes;
  dia = dia < 10 ? '0' + dia : dia;

  return anio + '-' + mes + '-' + dia;
}
 
/********************************************************************
/ * COUNTDOWN HEADER
 ********************************************************************/
function contador_TopHeader(horafin = 0) {
    var second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 1;

    var horas_fin = [24]; //, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22];
    var hora_fin = horafin;
    var dia = new Date();
    var hora_actual = dia.getHours();

    horas_fin.forEach((element, index, array) => {
        if (element > hora_actual && hora_fin == 0) hora_fin = horas_fin[index];
    });
    
    countDown = new Date(dia);
    if (hora_fin != 0) {
        countDown.setHours(hora_fin);
        countDown.setMinutes(0);
        countDown.setSeconds(0);
    } else {
        countDown.setDate(dia.getDate() + 1);
        countDown.setHours(0);
        countDown.setMinutes(0);
        countDown.setSeconds(0);
    }  
  
    x = setInterval(function () {
        let fecha = new Date();
        let now = new Date().getTime();
            distance = countDown - now;
        let horas = (Math.floor((distance / (hour))));
        let minutos = Math.floor((distance % (hour)) / (minute));
        let segundos = Math.floor((distance % (minute)) / second);                

        //document.getElementById("contador").style.display = 'flex';
              
        document.getElementById("horas").innerText = (horas < 10) ? ("0" + horas) : horas;
        document.getElementById("minutos").innerText = (minutos < 10) ? ("0" + minutos) : minutos;
        document.getElementById("segundos").innerText = (segundos < 10) ? ("0" + segundos) : segundos;
        
        if (distance < 0) {            
            document.getElementById("horas").innerText = "0";
            document.getElementById("minutos").innerText = "0";
            document.getElementById("segundos").innerText = "0";
            clearInterval(x);
        }
    }, 800)
}

/********************************************************************
 * COUNTDOWN POPUP
 ********************************************************************/
function contador_js(horafin = 0) {
    const second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 1;

    let horas_fin = [24]; //, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22];
    let hora_fin = horafin;
    let dia = new Date();
    let hora_actual = dia.getHours();

    horas_fin.forEach((element, index, array) => {
        if (element > hora_actual && hora_fin == 0) hora_fin = horas_fin[index];
    });
        
    countDown = new Date(dia);
    if (hora_fin != 0) {
        countDown.setHours(hora_fin);
        countDown.setMinutes(0);
        countDown.setSeconds(0);
    } else {
        countDown.setDate(dia.getDate() + 1);
        countDown.setHours(0);
        countDown.setMinutes(0);
        countDown.setSeconds(0);
    }

    x = setInterval(function () {
        let fecha = new Date();
        let now = new Date().getTime();
            distance = countDown - now;
        let horas = (Math.floor((distance / (hour))));
        let minutos = Math.floor((distance % (hour)) / (minute));
        let segundos = Math.floor((distance % (minute)) / second);                
            
        document.getElementById("OP_horas").innerText = (horas < 10) ? ('0' + horas) : horas;
        document.getElementById("OP_minutos").innerText = (minutos < 10) ? ("0" + minutos) : minutos;
        document.getElementById("OP_segundos").innerText = (segundos < 10) ? ("0" + segundos) : segundos;
      
        if (distance < 0) {
            document.getElementById("OP_horas").innerText = "0";
            document.getElementById("OP_minutos").innerText = "0";
            document.getElementById("OP_segundos").innerText = "0";
  
            clearInterval(x);
        }
    }, 0)
}

function contador_PopUp(con_contador) {
  const aspa = document.getElementById("OP_popup_countdown_close_modal_id");
  const button = document.getElementById("btn_popup_countdown_cerrar");
  
  if (button)
    button.addEventListener('click', (event) => {
        event.preventDefault(); 
        event.stopPropagation();                    
        document.getElementById("OP_popup_countdown").classList.remove("OP_open");    
    });
  
  if (aspa)
    aspa.addEventListener('click', (event) => {
        event.preventDefault(); 
        event.stopPropagation();                    
        document.getElementById("OP_popup_countdown").classList.remove("OP_open");    
    });
  
  if (!window.sessionStorage.getItem('CDown')) {
      setTimeout(function () {
          document.getElementById("OP_popup_countdown").classList.add("OP_open");
          if (con_contador) contador_js(20);
      }, 3 * 1000);
      window.sessionStorage.setItem('CDown','true');
  }
}